import Image from 'next/legacy/image';

import { FilterPill } from 'types/srpFilters';
import closePill from 'public/static/images/close-pill.svg';
import { fonts, screen } from 'components/styles/variables';

export default function ActiveFilterPill({
  pill,
  removeFilter,
}: {
  pill: FilterPill;
  removeFilter: (removedFilter: FilterPill) => void;
}): JSX.Element {
  return (
    <>
      <div
        className={'autos-pill'}
        data-name="make"
        data-value={pill.label}
        key={pill.name}
        data-testid={`${pill.name}-filter-pill`}
      >
        <span className={'autos-pill-label'} style={{ textTransform: 'capitalize' }}>
          {pill.label}
        </span>
        <span className={'autos-pill-close'}>
          <Image
            src={closePill}
            alt="close pill"
            height={13}
            width={13}
            data-testid="pill-close"
            onClick={(): void => removeFilter(pill)}
          />
        </span>
      </div>
      <style jsx>{`
        .autos-pill {
          position: relative;
          padding: 1px 10px; // check with eddie whether he wants fixed height of 28px - 1px was 5px
          padding-right: 30px;
          color: #333333;
          font-size: 14px;
          border: 1px solid #d3d3d3;
          border-radius: 8px;
          font-family: ${fonts.default};
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.2px;
          margin: 0 6px;
          position: relative;
          top: -0.5px;
        }
        .autos-pill:first-child {
          margin-left: 4px;
        }
        .autos-pill-close {
          height: 100%;
          position: absolute;
          top: 0px;
          right: 0px;
          cursor: pointer;
          padding: 2px 8px 0 6px;
        }
        @media (max-width: ${screen.lgMin}) {
          .filter-pills-list {
            display: none;
          }
        }
        @media (min-width: ${screen.smMin}) {
          .autos-pill {
            margin-bottom: 9px;
          }
        }
      `}</style>
    </>
  );
}
